import(/* webpackMode: "eager" */ "/app/src/app/(protected)/page.tsx");
